export const authorizeMenu = (info: any, menu_id: number): boolean => {
  const { menu = [] }: { menu?: any[] } = info || {};

  return menu.length > 0 && menu.findIndex((module: any) => module.menu.menu_id === menu_id) > -1;
};
